import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

import { Country } from './country.model';
@Injectable()
export class CountryService extends AbstractEntityService {

    protected resourceUrl = 'api/countries';
    private resourceNoAuthUrl = 'api/no-auth/countries';
    private resourceSearchUrl = 'api/_search/countries';
    protected resourceCountUrl = 'api/_search/count/countries';

    constructor(protected http: HttpClient) { super(http); }

    create(country: Country): Observable<Country> {
        let copy: Country = Object.assign({}, country);
        return this.http.post<Country>(this.resourceUrl, copy).map((res: Country) => {
            return res;
        });
    }

    update(country: Country): Observable<Country> {
        let copy: Country = Object.assign({}, country);
        return this.http.put<Country>(this.resourceUrl, copy).map((res: Country) => {
            return res;
        });
    }

    find(id: number): Observable<Country> {
        return this.http.get<Country>(`${this.resourceUrl}/${id}`).map((res: Country) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<Country[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Country[]>>(this.resourceUrl, options);
    }

    queryNoAuth(req?: any): Observable<HttpResponse<Country[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Country[]>>(this.resourceNoAuthUrl, options);
    }

    search(req?: any): Observable<HttpResponse<Country[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Country[]>>(this.resourceSearchUrl, options);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/country/country.service.ts